module.exports = {
	"about": "எம்மைப்பற்றி",
	"accepted_invitation_from": "நீங்கள் {invitedBy} இருந்து அழைப்பை ஏற்றுக்கொண்டு,{coins}ஐ போனஸ் ஆக பெற்றீர்கள்",
	"accepted_invitation_from_friend": "உங்கள் நண்பர் {displayName} உங்கள் அழைப்பை ஏற்றுக்கொண்டார்! {coins}ஐ போனஸ் ஆக பெற்றீர்கள்",
	"account_disabled": "உங்கள் கணக்கு முடக்கப்பட்டது, தயவுசெய்து hello@cricrush.comஐ தொடர்பு கொள்ளவும்",
	"all_entries": "அனைத்து பதிவுகள்",
	"already_registered": "முன்னரே கணக்கு இருந்தால்?",
	"can_t_find_account": "உங்கள் கணக்கைக் கண்டுபிடிக்க முடியவில்லை. தயவுசெய்து கணக்கொன்றை உருவாக்கவும்!",
	"cant_placed_entries": "நீங்கள் பதிவுகள் எதுவும் செய்யவில்லை",
	"change_profile_picture": "படத்தை மாற்றவும்",
	"chat_modal_name": "அரட்டை",
	"claim": "பெறுவதிற்கு",
	"click_here_to_resend": "மின்னஞ்சலை மீண்டும் அனுப்புக",
	"close": "விலகு",
	"coming_soon": "விரைவில்",
	"confirm": "உறுதிப்படுத்து",
	"countdown_day": "நாள்",
	"countdown_days": "நாட்கள்",
	"countdown_hours": "மணித்தியாலங்கள்",
	"countdown_minutes": "நிமிடங்கள்",
	"countdown_seconds": "விநாடிகள்",
	"create_account": "உங்கள் கணக்கை ஆரம்பியுங்கள்",
	"cricrush_league": "Cricrush லீக்",
	"do_not_have_an_account": "உங்களிடம் கணக்கு இல்லையா?",
	"dream_team": "டிரீம் ரீம்",
	"dream_team_entry": "டிரீம் ரீம் பதிவு",
	"dream_team_entry_creation_modal_name": "டிரீம் ரீம் பதிவு உருவாக்கம்",
	"dream_team_leagues": "டிரீம் டீம் லீக்ஸ்",
	"earn_coins_bonuses": "போனஸ் நாணயங்களை சம்பாதிக்கவும்",
	"edition": "பதிப்பு",
	"email_not_verified": "மின்னஞ்சல் சரிபார்க்கப்படவில்லை.",
	"email_not_verified_to_claim_rewards": "வெகுமதிகளை பெற உங்கள் மின்னஞ்சலை சரிபார்க்கவும்.",
	"email_title": "மின்னஞ்சல்",
	"enter_valid_email": "சரியான மின்னஞ்சலை உள்ளிடவும்",
	"entries": "பதிவுகள்",
	"entry_created": " -  பதிவு உருவாக்கப்பட்டது",
	"favourite_teams": "பிடித்த அணிகள்",
	"fb_reauth": "பேஸ்புக் மூலம் உறுதிப்படுத்தவும்",
	"fb_signin": "பேஸ்புக் மூலம் உள்நுழைக",
	"fb_signup": "பேஸ்புக் மூலம் பதிவு செய்க",
	"fire_base_already_login_different provider": "வெவ்வேறு வழங்குநரைப் பயன்படுத்தி முன்னர் உள்நுழைந்தீர்கள், சரியான வழங்குனரைப் மீண்டும் பயன்படுத்தி உள்நுழைக.",
	"fire_base_wrong_message": "ஏதோ தவறு நடந்துவிட்டது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்!",
	"friend_invite_accepted": "உங்கள் நண்பர் {friendName} உங்கள் அழைப்பை ஏற்றுக்கொண்டார்",
	"ggl_reauth": "கூகிள்ஆல் உறுதிப்படுத்தவும்",
	"ggl_signin": "கூகிள்ஆல் உள்நுழைக",
	"ggl_signup": "கூகிள்ஆல் பதிவுசெய்தல்",
	"go_back": "திரும்பி செல்ல",
	"help": "உதவி",
	"invalid_mail": "தவறான மின்னஞ்சல் முகவரி",
	"invitation_accepted": "அழைப்பிதழ் ஏற்றுக்கொள்ளப்பட்டது!",
	"invitation_bonus": "அழைப்பிதழ் போனஸ்",
	"invite_friends": "நண்பர்களை அழைக்க",
	"leaderboard": "Leaderboard",
	"live": "Live",
	"live_prediction": "லைவ் ப்ரீடிக்ஷன் லீக்",
	"live_prediction_entry": "லைவ் ப்ரீடிக்ஷன் பதிவு",
	"login": "உள் நுழைக",
	"login_here": "உள் நுழைவதற்கு்",
	"login_register": "உள்நுழைய / கணக்கை ஆரம்பிக்க",
	"logout": "வெளியேறு",
	"lost": " - இழந்தது",
	"lost_title": "இழந்தது",
	"no_email_with_account": "இந்த மின்னஞ்சலுக்கு கணக்கு இல்லை, தயவுசெய்து புதிய கணக்கை ஆரம்பிக்கவும்",
	"no_network": "நெட்வொர்க் இல்லை!",
	"no_network_connection": "நெட்வொர்க் இணைப்பு இல்லை!",
	"notifications": "அறிவிப்புகள்",
	"or": "அல்லது",
	"password_incorrect": "நீங்கள் உள்ளிட்ட கடவுச்சொல் தவறானது.",
	"pick_your_country": "உங்கள் நாட்டைத் தேர்ந்தெடுக்கவும்",
	"play_button": "விளையாடு",
	"predict_score": "போட்டியின் டார்கெட் ஸ்கோரை ஊகிக்கவும்",
	"profile": "சுயவிபரம்",
	"providers_str": "நீங்கள் {providersStr} முன்னர் பயன்படுத்தினீர்கள். அதே முறையை மீண்டும் பயன்படுத்தி உள்நுழைக",
	"providers_str_try_google": "முன்பு நீங்கள் {providersStr} பயன்படுத்தி உள்நுழைந்தீர்கள். கூகிள் ஐப் பயன்படுத்தி உள்நுழைய முயற்சிக்கவும்",
	"reauth_modal_title": " நடவடிக்கையை முடிக்க மீண்டும் அங்கீகரிக்கவும்",
	"received_invitation_bonus": "அழைப்பிதழ் போனஸ் பெறப்பட்டது",
	"refunded": " - திருப்பிக்கொடுத்த",
	"refunded_title": "திருப்பிக்கொடுத்த",
	"register_here": "இங்கே பதிக",
	"save": "சேமிக்கவும்",
	"select_country": "பிரத்தியேக வெற்றிகளை அனுபவிக்க உங்கள் நாட்டினை தெரிவுசெய்யவும்.!",
	"select_language": "மொழியைத் தேர்ந்தெடுங்கள்",
	"select_teams": "பிடித்த அணிகள்",
	"settings": "அமைப்புகள்",
	"submit": "சமர்ப்பிக்கவும்",
	"target_prediction": "டார்கெட் ப்ரீடிக்ஷன்",
	"target_prediction_entry": "டார்கெட் ப்ரெடிக்ஷன் பதிவு",
	"total": "மொத்தம்",
	"transactions": "பரிவர்த்தனைகள்",
	"unknown_error": "எதிர்பார்க்காத முடிவு பெறப்பட்டுள்ளது. தயவு செய்து hello@cricrush.comஐ தொடர்பு கொள்ளவும்.",
	"upcoming": "எதிர்வரும்",
	"user_name": "பயனர் பெயர்",
	"valid_number": "சரியான எண்ணை உள்ளிடுக!",
	"weak_password": "பலவீனமான கடவுச்சொல், கடவுச்சொல் 6 எழுத்துகள் அல்லது அதற்கு மேற்பட்டதாக இருக்க வேண்டும்.",
	"won": " - வெற்றி பெற்ற",
	"won_lost_refunded_coins": "இந்த ஆட்டத்தில் நீங்கள் {earnedCoins} நாணயங்களைப் பெற்றுள்ளீர்கள், {lostCoins} நாணயங்களை இழந்துள்ளீர்கள், {refundedCoins} நாணயங்களை திரும்ப பெற்றுள்ளீர்கள் ",
	"won_title": "வெற்றி",
	"you_lost_message": "இழந்தவை",
	"you_won": "வென்றவை ",
	"you_won_reward": "நீங்கள் ஒரு பரிசை வென்றுள்ளீர்கள்",
	"your_entries": "உங்கள் பதிவுகள்",
	"your_live_prediction_entry": "உங்கள் லைவ் ப்ரீடிக்ஷன் பதிவு : {prediction}",
	"your_mom_entry": "உங்கள் ஆட்டநாயகன் பதிவு :{momEntry}",
	"your_prediction": "உங்கள்  ப்ரெடிக்ஷன் : {prediction}",
	"display_name": "காட்சி பெயர்",
	"email": "மின்னஞ்சல்",
	"password": "கடவுச்சொல்",
	"runs_cannot_be_negative_value": "ஓட்டங்கள் எதிர்மறை பெறுமதியில் இருக்க முடியாது",
	"budget": "பட்ஜெட் $",
	"view_button": "நோக்கு",
	"score": "மதிப்பெண்: ",
	"rank": "நிலை: ",
	"target_prediction_leagues": "டார்கெட் ப்ரீடிக்ஷன் லீக்ஸ்",
	"live_prediction_leagues": "லைவ் ப்ரீடிக்ஷன் லீக்ஸ் ",
	"target_prediction_description": "ஆட்ட நிர்ணய ஒட்டத்தை ஊகித்து உங்கள் பதிவை உருவாக்கவும். உங்கள் ஊகம் எவ்வளவு அண்ணளவாக உள்ளது என்பதை பொறுத்து நீங்கள் தரவரிசை படுத்தப்படுவீர்கள். ",
	"required": "கட்டாயம்!",
	"entries_left": " பதிவுகள் இன்னும் உள்ளன ",
	"end_of_results": "இறுதி முடிவு!",
	"invalid_email_address": "தவறான மின்னஞ்சல் முகவரி",
	"completed": "முடிவடைந்து விட்டது",
	"dream_team_description": "நான்கு பேர் கொண்ட அணியை தெரிவு செய்து உங்கள் பதிவை உருவாக்குக. உங்கள் அணி உங்களுக்காக பெற்றுத்தரும் ஓட்டங்களை பெற்று மகிழ்ந்திருங்கள்.",
	"reward_claimed_title": "பரிசை பெற்றுக்கொள்க - {reference}",
	"reward_claimed_msg": "Redeemed coins by claiming reward with reference - {reference}",
	"update": "மேம்படுத்த",
	"processed": "பரிசீலிக்கப்பட்டது",
	"claim_reward_instructions_title": "தயவுசெய்து வழிமுறைகளை கவனமாக வாசிக்கவும்!",
	"invalid_filed_instruction": "{field} தவறானது. தயவுசெய்து சரிபார்க்கவும்!",
	"reward_processed": "Reward Processed!",
	"reward_reference": "உங்களது  குறிப்பு இலக்கம்  : {reference}",
	"claim_coins_message": "இப் பரிசை பெறுக்கொள்வதன் மூலம் உங்களது நாணயங்கள் {claimCoins}ஆல் குறைக்கப்படுகின்றது.",
	"weekly": "வாராந்த",
	"daily": "நாளாந்த",
	"monthly": "மாதாந்த",
	"lifetime": "ஆயுட்கால",
	"local": "Local",
	"global": "Global",
	"no_lb_status_generated": "உங்களது leader boardஐ பெற்றுக்கொள்ள போதுமான தரவு இல்லை!",
	"you": "நீங்கள்",
	"leaderBoard": "Leader Board",
	"mail_sent": "மின்னஞ்சல் அனுப்பப்பட்டது!",
	"verification_mail_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் {email}க்கு அனுப்பப்பட்டது",
	"messages": "தகவல்கள்",
	"country_change_warning": "நாட்டினை மாற்றுவதன் மூலம் தங்களது leaderboard தரவரிசகளை இழக்கநேரிடலாம்.",
	"faq": "FAQ",
	"how_scores_calculated": "கணிப்பு விதிமுறைகள்.",
	"how_to_play": "விளையாடும் முறை",
	"live_prediction_description": "{endOver}வது பந்துபரிமாற்ற முடிவில் உங்களது {teamName}அணியின் ஓட்ட எண்ணிக்கையை ஊகிக்கவும். அணியின் உண்மையான  ஓட்ட எண்ணிக்கையை வைத்து தங்களது பதிவின் தரவரிசை கணிக்கப்படும்.",
	"predict_what_message": "{endOver}வது பந்துபரிமாற்ற முடிவில் உங்களது {teamName}அணியின் ஓட்ட எண்ணிக்கையை ஊகிக்கவும்.",
	"pick_team": "நான்கு பேர்கொண்ட அணியை தெரிவுசெய்து வெற்றிபெறுக",
	"your_entry_created": "உங்களது பதிவு உருவாக்கப்பட்டது!",
	"fica_title": "Officially endorsed by",
	"fica_detailed_text": "Cricrush மட்டுமே FICA ஆல் ஒப்புதலளிக்கப்பட ஒரேயொரு செயலியாகும் ",
	"version": "பதிப்பு",
	"match_help": "Click here to select a match",
	"dream_team_leagues_help": "Click here to select your 4 player team for {matchName}",
	"quick_prediction_leagues_help": "Click here to predict the score at the end of {over}th over",
	"target_prediction_leagues_help": "Click here to predict the target score of {matchName} match",
	"entries_help": "Click here to view your entry scores and ranks updated in real time with live match",
	"more_leaderboard_help": "Click here to check your leaderboard",
	"more_edition_language_help": "Click here and select edition to change your language",
	"more_edition_country_help": "Click here and select edition to change your country",
	"add_coins_help": "Running out of coins? Earn more free coins here",
	"claimed": "Claimed",
	"invite_friends_title": "Invite your friends and get 100 coins when they place their first entry!",
	"daily_claim_bonus_counter_message": "You have already claimed your bonus!",
	"daily_claim_bonus_message": "Claim your free coins now!",
	"daily_login_bonus": "Daily login bonus",
	"daily_login_bonus_claimed": "Daily login bonus claimed",
	"invite_friends_share_title": "Your friend {name} has invited you to join Cricrush",
	"invite_friends_share_message": "Your friend {name} has invited you to join Cricrush. Click the link below to join, play and win exciting gifts",
	"invite_friends_dialog_title": "Invite friends to join",
	"live_status": "LIVE",
	"view_entries": "View {noOfEntries} entries >>",
	"end_of_results2": "That's all we have!",
	"leagues_not_created": "Leagues will be created soon...",
	"add_coins": "Add Coins",
	"expired": "Expired",
	"reward_expired": "Reward Expired!",
	"entries_left2": "{noOfEntries} பதிவுகள் இன்னும் உள்ளன "
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/ta.json
// module id = 489
// module chunks = 0